"use client";

import * as React from "react";
import { useEffect, useState } from "react";
import { ArrowRight, Code, Database, Lock, Server, Terminal } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
const projects = [{
  id: "case-06",
  title: "MIV - Mecanizados Industriales de Venezuela",
  category: "MECANIZADO INDUSTRIAL ",
  status: "Reparación y mecanizado de equipos críticos",
  image: "https://recla360.com/wp-content/uploads/2026/05/Intercambiador_Tiny.jpg?v=xqhg4qx4qi9",
  specs: ["Mecanizado", "Reparación Industrial", "Cajas reductoras"],
  description: "Plataforma técnico-industrial con sistemas de mecanizado, automatización de procesos y gestión integral de equipos críticos."
}, {
  id: "case-07",
  title: "RECLA360\nArquitectura",
  category: "ARQUITECTURA",
  status: "Diseño web para arquitectos y captación de clientes",
  image: "https://recla360.com/wp-content/uploads/2026/05/miv-grupo.webp?v=8kahz2a1n4",
  specs: ["Portafolio Visual", "Diseño Profesional", "Generación Clientes"],
  description: "Sistema digital para firmas arquitectónicas que integra portafolio, gestión de proyectos y automatización de cliente potencial."
}, {
  id: "case-01",
  title: "Venchandlers Nexus - Global Ship Supply",
  category: "MARÍTIMO",
  status: "Plataforma Marítima Internacional",
  image: "https://recla360.com/wp-content/uploads/2026/05/Hero-Tanquero-1400_Tiny.jpg?v=bmo9b3jtyu",
  specs: ["Ship Supply", "Procurement", "Global Network"],
  description: "Plataforma global de suministros marítimos con integraciones API, sistemas de logística avanzada y red comercial internacional automatizada."
}, {
  id: "case-05",
  title: "KJHR Servicios al Hogar",
  category: "SERVICIOS",
  status: "Top 1 en su Ciudad",
  image: "https://recla360.com/wp-content/uploads/2026/04/2026-04-10.png?v=bxtlba5b71o",
  specs: ["E-commerce Local", "SEO Técnico", "Maps"],
  description: "Dominio absoluto del mercado local frente a grandes superficies gracias a estrategia SEO."
}, {
  id: "case-02",
  title: "Taller Mecánico AutoPro",
  category: "Taller",
  status: "+65% Citas Mensuales",
  image: "https://big-chipmunk-1.10web.cloud/wp-content/uploads/2026/03/taller-mecanico.jpeg?v=grprgfr4hyc",
  specs: ["Ads Locales", "Gestión Reseñas", "Web Móvil"],
  description: "Automatización de citas y posicionamiento en los primeros resultados de búsqueda."
}, {
  id: "case-03",
  title: "Bar La Esquina",
  category: "Hostelería",
  status: "Lleno cada fin de semana",
  image: "https://big-chipmunk-1.10web.cloud/wp-content/uploads/2026/03/bar.jpeg?v=a5bcncuws39",
  specs: ["Menú Digital", "Local SEO", "Instagram Ads"],
  description: "Transformación digital completa: de local vacío a reservas agotadas mediante Google Maps."
}, {
  id: "case-04",
  title: "Carnicería Premium",
  category: "Carnicería",
  status: "+40% Ventas Directas",
  image: "https://big-chipmunk-1.10web.cloud/wp-content/uploads/2026/03/Carniceria.jpeg?v=sblbcc9jrs",
  specs: ["Catálogo Online", "Google Business", "SEO"],
  description: "Digitalización del catálogo tradicional permitiendo pedidos directos por WhatsApp.",
  imageClassName: "text-card-foreground flex flex-col gap-6 py-6 pt-0 h-full overflow-hidden border-border/40 bg-card/20 backdrop-blur-md transition-all duration-500 hover:border-primary/60 hover:shadow-2xl hover:shadow-primary/10 rounded-lg !bg-[url(https://recla360.com/wp-content/uploads/2026/04/Ancla4-1.jpg)]"
}];
export default function SolutionsArchive() {
  const [api, setApi] = useState<CarouselApi>();
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  useEffect(() => {
    if (!api) return;
    const onSelect = () => {
      setCanScrollPrev(api.canScrollPrev());
      setCanScrollNext(api.canScrollNext());
    };
    onSelect();
    api.on("select", onSelect);
    api.on("reInit", onSelect);
    return () => {
      api.off("select", onSelect);
      api.off("reInit", onSelect);
    };
  }, [api]);
  return <section data-section-id="15254" id="resultados-en-tu-sector" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-30" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-30" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6 border-b border-border/20 pb-8">
          <div className="space-y-3">
            <h2 className="text-4xl md:text-5xl font-sans font-extrabold tracking-tighter text-primary uppercase italic">SOLUCIONES IMPLEMENTADAS&nbsp;</h2>
            <p className="text-muted-foreground max-w-lg text-base md:text-lg font-medium">Empresas y sectores técnico-comerciales transformados mediante arquitectura digital, automatización AI e integración de sistemas inteligentes.</p>
          </div>
          <div className="flex items-center gap-3 text-xs font-mono text-muted-foreground tracking-widest">
            <Terminal className="w-4 h-4 text-secondary" />
            <span>RECLA_360_ACTIVE</span>
            <span className="animate-pulse text-secondary">●</span>
          </div>
        </div>

        <Carousel setApi={setApi} opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-4 mb-6 md:mb-8">
            {projects.map((project, index) => {
            const isFirst = index === 0;
            const cardContent = <Card className={`${project.imageClassName || ""} h-full overflow-hidden border-border/40 bg-card/20 backdrop-blur-md transition-all rounded-lg hover:border-primary/60 ${isFirst ? "duration-300 hover:shadow-[0_8px_24px_rgba(0,191,255,0.3),0_0_20px_rgba(0,191,255,0.2)]" : "duration-500 hover:shadow-2xl hover:shadow-primary/10"}`}>
                  <CardContent className="p-0">
                    <AspectRatio ratio={16 / 9} className="relative overflow-hidden">
                      {}
                      <img src={project.image} alt={project.title} loading="lazy" data-wvc-srcset={`${project.image}-wvc-srcset`} data-wvc-sizes={`${project.image}-wvc-sizes`} className={`object-cover w-full h-full grayscale group-hover:grayscale-0 ${isFirst ? "transition-transform duration-300 group-hover:scale-[1.07] opacity-50 group-hover:opacity-40" : "transition-transform duration-700 group-hover:scale-110 opacity-50 group-hover:opacity-30"}`} />
                      
                      {isFirst && <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 pointer-events-none" />}

                      {}
                      <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent p-6 flex flex-col justify-end transition-opacity duration-500 group-hover:opacity-0">
                        <div className="space-y-3">
                          <Badge variant="outline" className="bg-primary/10 backdrop-blur-lg border-primary/40 text-primary font-mono text-[10px] uppercase tracking-widest px-3">
                            {project.category}
                          </Badge>
                          <h3 className="text-2xl font-bold tracking-tight text-foreground">
                            {project.title}
                          </h3>
                          <div className="flex items-center gap-2 text-sm text-secondary font-bold">
                            <span className="inline-block w-2.5 h-2.5 rounded-lg bg-secondary animate-pulse" />
                            {project.status}
                          </div>
                        </div>
                      </div>

                      {}
                      <div className="absolute inset-0 bg-background/95 p-8 flex flex-col justify-between opacity-0 transition-opacity duration-500 group-hover:opacity-100 border-t-2 border-primary">
                        <div className="space-y-5">
                          <div className="flex justify-between items-start">
                            <h3 className="text-lg font-black text-secondary font-mono tracking-tighter">
                              {project.id.toUpperCase()}
                            </h3>
                            <Code className="w-6 h-6 text-primary opacity-70" />
                          </div>
                          
                          <div className="space-y-3">
                            <p className="text-xs text-foreground font-bold uppercase tracking-widest opacity-80">
                              Estrategia Aplicada
                            </p>
                            <div className="flex flex-wrap gap-2">
                              {project.specs.map((spec, i) => <Badge key={i} variant="secondary" className="text-[10px] px-2 py-1 h-6 font-mono bg-primary/20 text-primary hover:bg-primary/30 border-none rounded-sm">
                                  {spec}
                                </Badge>)}
                            </div>
                          </div>
                          
                          <p className="text-sm text-muted-foreground leading-relaxed italic">
                            "{project.description}"
                          </p>
                        </div>

                        <div className="pt-6 border-t border-border/20">
                          <Button asChild variant="ghost" size="sm" className="w-full justify-between group/btn hover:bg-primary hover:text-primary-foreground transition-all duration-300 rounded-sm">
                            {isFirst ? <span className="font-bold uppercase tracking-tighter text-xs flex items-center justify-between w-full">
                                <span>Ver Caso Completo</span>
                                <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-2" />
                              </span> : <div className="font-bold uppercase tracking-tighter text-xs flex items-center justify-between w-full">
                                <span>Ver Caso Completo</span>
                                <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-2" />
                              </div>}
                          </Button>
                        </div>
                      </div>

                      {isFirst && <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-30 pointer-events-none">
                          <div className="bg-black/60 backdrop-blur-md text-white px-6 py-3 rounded-sm font-bold text-sm uppercase tracking-widest border border-white/20 shadow-2xl flex items-center gap-2">
                            <span>View Project</span>
                            <ArrowRight className="w-4 h-4" />
                          </div>
                        </div>}
                    </AspectRatio>
                  </CardContent>
                </Card>;
            return <CarouselItem key={project.id} data-index={index} className="pl-4 md:basis-1/2 lg:basis-1/3 xl:basis-1/3">
                  {project.id === "case-06" ? <Link to="https://mivgrupo.com" newTab className="group relative h-full block">
                      {cardContent}
                    </Link> : project.id === "case-07" ? <Link to="https://unified-squid.10web.cloud" newTab className="group relative h-full block">
                      {cardContent}
                    </Link> : project.id === "case-01" ? <Link to="https://venchandlersnexus.com" newTab className="group relative h-full block">
                      {cardContent}
                    </Link> : project.id === "case-05" ? <Link to="https://sacramentohandymanpros.com" newTab className="group relative h-full block">
                      {cardContent}
                    </Link> : <div className="group relative h-full">
                      {cardContent}
                    </div>}
                </CarouselItem>;
          })}
          </CarouselContent>
          
          <div className="flex justify-center gap-4 md:gap-6 mt-8 md:mt-12 px-4">
            <CarouselPrevious disabled={!canScrollPrev} className="static translate-y-0 translate-x-0 bg-transparent text-white md:text-electric-blue disabled:text-gray-300 md:hover:bg-primary md:hover:text-primary-foreground border-primary/30 w-12 h-12 rounded-sm active:scale-95 touch:bg-primary" />
            <CarouselNext disabled={!canScrollNext} className="static translate-y-0 translate-x-0 bg-transparent text-white md:text-electric-blue disabled:text-gray-300 md:hover:bg-primary md:hover:text-primary-foreground border-primary/30 w-12 h-12 rounded-sm active:scale-95 touch:bg-primary" />
          </div>
        </Carousel>
      </div>
    </section>;
}